// extracted by mini-css-extract-plugin
export default {"dialog":"Modal_dialog__nbrmD"};